import { render, staticRenderFns } from "./LandUseChangeForm.vue?vue&type=template&id=a7fa3bcc"
import script from "./LandUseChangeForm.vue?vue&type=script&lang=js"
export * from "./LandUseChangeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports